"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emit = emit;
exports.listen = listen;

if (typeof window.CustomEvent !== 'function') {
  // eslint-disable-next-line global-require
  require('./polyfill.js');
}

function emit(_ref) {
  var appName = _ref.appName,
      eventName = _ref.eventName,
      payload = _ref.payload;
  var event = new CustomEvent("ansarada:".concat(appName, ":").concat(eventName), {
    detail: {
      appName: appName,
      eventName: eventName,
      payload: payload
    }
  });
  window.dispatchEvent(event);
}

function listen(_ref2) {
  var appName = _ref2.appName,
      eventName = _ref2.eventName,
      callback = _ref2.callback;

  var handleEvent = function handleEvent(event) {
    event.stopPropagation();
    callback(event.detail);
  };

  window.addEventListener("ansarada:".concat(appName, ":").concat(eventName), handleEvent); // Return an abstraction for this listener that allows it to be removed.

  var theListener = {
    remove: function remove() {
      window.removeEventListener("ansarada:".concat(appName, ":").concat(eventName), handleEvent);
    }
  };
  return theListener;
}